import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CedulasComponent } from './components/cedulas/cedulas.component';
import { LoginComponent } from './components/login/login.component';
import { PasswordInicialComponent } from './components/password-inicial/password-inicial.component';
import { PasswordOlvidadoComponent } from './components/password-olvidado/password-olvidado.component';
const routes: Routes = [
  {path:'', pathMatch:'full', component:LoginComponent},
  {path: 'cedulas', component:LoginComponent},
  {path: 'cedulas/:rfc', component:CedulasComponent},
  {path: 'listacedulas', component:CedulasComponent},
  {path: 'cambioPasswordInicial', component:PasswordInicialComponent},
  {path: 'cambioPasswordInicial/:id', component:PasswordInicialComponent},
  {path: 'cambiaPasswordOlvido', component:PasswordOlvidadoComponent},
  {path: '**', redirectTo: ''}
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
